<template>
  <layout>
    <div slot="content">
      <i-card :title="this.$route.meta.title">
        <div slot="content">
          <div>
            <el-form :inline="true" size="small" style="text-align: right">
              <el-form-item>
                <el-input placeholder="订单号" v-model="filter.trade_code" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-input placeholder="商品名称" v-model="filter.title" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="filter.linker_mobile" placeholder="联系人手机号" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="filter.linker_name" placeholder="联系人姓名" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-date-picker v-model="filter.use_date" style="width: 175px" value-format="yyyy-MM-dd" type="date"
                                placeholder="出行日期" clearable></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getOrder(1)">查找</el-button>
                <el-button type="primary" @click="reset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div style="overflow-x: auto;padding-bottom: 20px;" v-loading="loading">
            <div class="no-data" v-if="orderList.length <= 0">暂无订单</div>
            <div class="table-card" v-for="item in orderList">
              <div class="order-info" :style="item.people.length > 0?'border-bottom:0':''">
                <div class="order-item" style="width: 100%">
                  商品名称:{{ item.title }}
                </div>
                <div class="order-item">
                  联系人:{{ item.linker_name }}
                </div>
                <div class="order-item">
                  联系人手机:{{ item.linker_mobile }}
                </div>
                <div class="order-item">
                  出行日期:{{ item.use_date }}
                </div>
                <div class="order-item">
                  购买数量:{{ item.goods_count }}张
                </div>
                <div class="order-item">
                  平台订单号:{{ item.trade_code }}
                </div>
                <div class="order-item">
                  票付通订单号:{{ item.pft_order_num }}
                </div>
                <div class="order-item">
                  票付通验票码:{{ item.pft_code }}
                </div>
                <div class="order-item">
                  外代验票码:{{ item.ticket_code || '无' }}
                </div>
                <div class="order-item">
                  订单金额:{{ item.total }}元
                </div>
                <div class="order-item">
                  支付状态:
                  <el-tag size="mini" :type="item.pay_status === 1?'success':'danger'">
                    {{ item.pay_status_name }}
                  </el-tag>
                </div>
                <div class="order-item">
                  当前步骤:
                  {{ item.create_step }}
                </div>
                <div class="order-item">
                  外代出票失败原因:
                  {{ item.ship_agent_fail_reason || '无' }}
                </div>
                <div class="order-item">
                  退款状态:
                  {{ item.refund_status_name }}
                </div>
                <div class="order-item">
                  外代取消失败原因:
                  {{ item.ship_agent_refund_fail_reason || '无' }}
                </div>
              </div>
              <table class="table">
                <td>姓名</td>
                <td>证件号</td>
                <td>证件类型</td>
                <td>外代游客ID</td>
                <td>使用状态</td>
                <td>使用日期</td>
                <tr v-for="people in item.people">
                  <td width="18%">{{ people.real_name }}</td>
                  <td width="18%">{{ people.cert_no }}</td>
                  <td width="18%">{{ people.cert_type }}</td>
                  <td width="18%">{{ people.guest_id }}</td>
                  <td width="18%">{{ people.use_status }}</td>
                  <td width="18%">{{ people.used_at || '未知' }}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="page-wrap">
            <el-pagination background :page-size="15" :current-page="pageInfo.current_page" layout="prev, pager, next"
                           @current-change="changePage" :total="pageInfo.total"/>
          </div>
        </div>
      </i-card>
    </div>
  </layout>
</template>

<script>
import orderDetails from "@/pages/order/order-detail-left"

export default {
  components: {
    orderDetails
  },
  name: "order-list",
  data() {
    return {
      orderList: [],
      showDetails: false,
      currUuid: "",
      filter: {
        linker_mobile: '',
        pay_status: '',
        trade_code: '',
        goods_type: '',
        resolve_status: '',
        title: ''
      },
      loading: false,
      pageInfo: {
        current_page: 1,
        total: 0,
      },
      giftList: [],
      resolveOrderDialog: false,
      resolveLoading: false,
      currSolveOrder: {
        uuid: "",
        gift: "",
      },
      refund: {
        showDialog: false,
        reason: "",
        orderUuid: "",
        refundLoading: false
      }
    }
  },
  methods: {
    getOrder: function (page = '', needScroll = true) {
      if (needScroll) {
        this.loading = true;
      }
      if (page) {
        this.pageInfo.current_page = page;
      }
      this.$http.request('nightShipOrderList', {
        filter: this.filter,
        page: this.pageInfo.current_page
      }).then(res => {
        this.orderList = res.data;
        this.loading = false;
        this.pageInfo = res.meta;
        if (needScroll) {
          window.scrollTo(0, 0)
        }
      });
    },
    changePage: function (page) {
      this.pageInfo.current_page = page;
      this.getOrder();
    },
    reset: function () {
      for (let i in this.filter) {
        if (i !== 'goods_type') {
          this.filter[i] = '';
        }
      }
      this.getOrder();
    },
    resolveOrder: function () {
      this.resolveLoading = true;
      this.$http.request('resolveOrder', this.currSolveOrder).then(res => {
        this.resolveLoading = false;
        if (res.status === 'success') {
          this.resolveOrderDialog = false;
          this.getOrder('', false);
        }
      }).catch(() => {
        this.resolveLoading = false;
      })
    },
    showRefund: function (uuid) {
      this.refund.showDialog = true;
      this.refund.orderUuid = uuid;
      this.refund.reason = "";
    },
    addRemark: function (id, remark) {
      this.$http.request('addPeopleRemark', {id: id, remark: remark}).then(res => {
        this.$notify({
          title: '成功',
          message: res.message,
          type: res.status,
          duration: 2000
        });
      });
    },
    doShowDetails: function (uuid) {
      this.currUuid = uuid;
      this.showDetails = true;
    }
  },
  created: function () {
    this.getOrder();
    this.filter['goods_type'] = this.$route.meta.goodsType;
  },
  watch: {
    '$route': function () {
      this.filter['goods_type'] = this.$route.meta.goodsType;
      this.getOrder();
    }
  }
}
</script>

<style scoped>

.table-card {
  width: 100%;
  font-size: 12px;
  margin-top: 30px;
}

.table-card .order-info {
  background: #f9f9f9;
  overflow: hidden;
  border: 1px solid #dcdcdc;
}

.table-card .order-info .order-item {
  float: left;
  width: 25%;
  padding: 5px 10px;
  box-sizing: border-box;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table tr:hover {
  background: #eee;
}

.table td {
  border: 1px solid #dcdcdc;
  padding: 10px;
}

.no-data {
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  margin-top: 30px;
}

.remark {
  cursor: pointer;
  padding: 3px 10px;
}

.remark:hover {
  box-shadow: 2px 2px 8px #888;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/settings/night_ship/order_list.vue